"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePolicyFailure = exports.updatePolicySuccess = exports.updatePolicyLoading = exports.updatePolicyRequest = exports.getPolicyByIdReset = exports.getPolicyByIdRequest = exports.getPolicyByNameReset = exports.getPolicyByNameFailure = exports.getPolicyByNameSuccess = exports.getPolicyByNameLoading = exports.getPolicyByNameRequest = exports.recursiveEditPermissionListReset = exports.recursiveEditPermissionListFail = exports.recursiveEditPermissionListSuccess = exports.recursiveEditPermissionListLoadingDisable = exports.recursiveEditPermissionListLoading = exports.recursiveEditPermissionListRequest = exports.recursiveEditRoleListReset = exports.recursiveEditRoleListFail = exports.recursiveEditRoleListSuccess = exports.recursiveEditRoleListLoadingDisable = exports.recursiveEditRoleListLoading = exports.recursiveEditRoleListRequest = void 0;

var _constants = require("./constants");

var recursiveEditRoleListRequest = function recursiveEditRoleListRequest(payload) {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_REQUEST,
    payload: payload
  };
};

exports.recursiveEditRoleListRequest = recursiveEditRoleListRequest;

var recursiveEditRoleListLoading = function recursiveEditRoleListLoading() {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_LOADING
  };
};

exports.recursiveEditRoleListLoading = recursiveEditRoleListLoading;

var recursiveEditRoleListLoadingDisable = function recursiveEditRoleListLoadingDisable() {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_LOADING_DISABLE
  };
};

exports.recursiveEditRoleListLoadingDisable = recursiveEditRoleListLoadingDisable;

var recursiveEditRoleListSuccess = function recursiveEditRoleListSuccess(payload) {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveEditRoleListSuccess = recursiveEditRoleListSuccess;

var recursiveEditRoleListFail = function recursiveEditRoleListFail(payload) {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveEditRoleListFail = recursiveEditRoleListFail;

var recursiveEditRoleListReset = function recursiveEditRoleListReset() {
  return {
    type: _constants.editRolesListType.RECURSIVE_EDIT_ROLES_LIST_RESET
  };
};

exports.recursiveEditRoleListReset = recursiveEditRoleListReset;

var recursiveEditPermissionListRequest = function recursiveEditPermissionListRequest(payload) {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_REQUEST,
    payload: payload
  };
};

exports.recursiveEditPermissionListRequest = recursiveEditPermissionListRequest;

var recursiveEditPermissionListLoading = function recursiveEditPermissionListLoading() {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING
  };
};

exports.recursiveEditPermissionListLoading = recursiveEditPermissionListLoading;

var recursiveEditPermissionListLoadingDisable = function recursiveEditPermissionListLoadingDisable() {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_LOADING_DISABLE
  };
};

exports.recursiveEditPermissionListLoadingDisable = recursiveEditPermissionListLoadingDisable;

var recursiveEditPermissionListSuccess = function recursiveEditPermissionListSuccess(payload) {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_SUCCESS,
    payload: payload
  };
};

exports.recursiveEditPermissionListSuccess = recursiveEditPermissionListSuccess;

var recursiveEditPermissionListFail = function recursiveEditPermissionListFail(payload) {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_FAILURE,
    payload: payload
  };
};

exports.recursiveEditPermissionListFail = recursiveEditPermissionListFail;

var recursiveEditPermissionListReset = function recursiveEditPermissionListReset() {
  return {
    type: _constants.editPermissionsListType.RECURSIVE_EDIT_PERMISSIONS_LIST_RESET
  };
};

exports.recursiveEditPermissionListReset = recursiveEditPermissionListReset;

var getPolicyByNameRequest = function getPolicyByNameRequest(name, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_JSON_REQUEST,
    payload: {
      name: name,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.getPolicyByNameRequest = getPolicyByNameRequest;

var getPolicyByNameLoading = function getPolicyByNameLoading() {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_JSON_LOADING
  };
};

exports.getPolicyByNameLoading = getPolicyByNameLoading;

var getPolicyByNameSuccess = function getPolicyByNameSuccess(EditPolicyData) {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_JSON_SUCCESS,
    payload: EditPolicyData
  };
};

exports.getPolicyByNameSuccess = getPolicyByNameSuccess;

var getPolicyByNameFailure = function getPolicyByNameFailure(reason) {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_JSON_FAILURE,
    payload: {
      error: reason
    }
  };
};

exports.getPolicyByNameFailure = getPolicyByNameFailure;

var getPolicyByNameReset = function getPolicyByNameReset() {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_JSON_RESET
  };
};

exports.getPolicyByNameReset = getPolicyByNameReset;

var getPolicyByIdRequest = function getPolicyByIdRequest(id, history, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_REQUEST,
    payload: {
      id: id,
      history: history,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.getPolicyByIdRequest = getPolicyByIdRequest;

var getPolicyByIdReset = function getPolicyByIdReset() {
  return {
    type: _constants.LoadPolicyDataType.EDIT_LOAD_POLICY_RESET
  };
};

exports.getPolicyByIdReset = getPolicyByIdReset;

var updatePolicyRequest = function updatePolicyRequest(data, history, policyEntity, consumer, consumerEntityId, redirectPath) {
  return {
    type: _constants.EditPolicyType.EDIT_POLICY_REQUEST,
    payload: {
      data: data,
      history: history,
      policyEntity: policyEntity,
      consumer: consumer,
      consumerEntityId: consumerEntityId,
      redirectPath: redirectPath
    }
  };
};

exports.updatePolicyRequest = updatePolicyRequest;

var updatePolicyLoading = function updatePolicyLoading() {
  return {
    type: _constants.EditPolicyType.EDIT_POLICY_LOADING
  };
};

exports.updatePolicyLoading = updatePolicyLoading;

var updatePolicySuccess = function updatePolicySuccess(response) {
  return {
    type: _constants.EditPolicyType.EDIT_POLICY_SUCCESS,
    payload: response
  };
};

exports.updatePolicySuccess = updatePolicySuccess;

var updatePolicyFailure = function updatePolicyFailure(reason) {
  return {
    type: _constants.EditPolicyType.EDIT_POLICY_FAILURE,
    payload: reason
  };
};

exports.updatePolicyFailure = updatePolicyFailure;